import React from 'react';

const ContactHero = () => {
  return (
    <section style={{ position: 'relative', height: '70vh', minHeight: '500px', overflow: 'hidden', background: '#050A12' }}>
      {/* Background photo */}
      <div style={{ position: 'absolute', inset: 0 }}>
        <img
          src="https://images.unsplash.com/photo-1726850027722-29724e6f9087"
          alt="Dramatic Norwegian coastal road winding along fjord cliffs with turquoise water below and misty mountains"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 40%', filter: 'brightness(0.32) contrast(1.25) saturate(0.65)' }} />
        
      </div>

      {/* Grain overlay */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\' opacity=\'0.04\'/%3E%3C/svg%3E")',
        opacity: 0.6, pointerEvents: 'none', zIndex: 2
      }} />

      {/* Blue diagonal block */}
      <div style={{
        position: 'absolute', bottom: 0, right: 0,
        width: '35%', height: '40%',
        background: '#3B6FD4',
        clipPath: 'polygon(100% 0%, 100% 100%, 0% 100%)',
        opacity: 0.1, zIndex: 1
      }} />

      {/* Vertical sidebar */}
      <div style={{
        position: 'absolute', left: 0, top: 0, bottom: 0,
        width: '52px',
        background: 'rgba(59,111,212,0.06)',
        borderRight: '1px solid rgba(59,111,212,0.15)',
        zIndex: 10,
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          writingMode: 'vertical-rl', transform: 'rotate(180deg)',
          fontFamily: 'Georgia, serif', fontStyle: 'italic',
          fontSize: '0.6rem', letterSpacing: '0.35em',
          color: 'rgba(59,111,212,0.7)', textTransform: 'uppercase',
          whiteSpace: 'nowrap'
        }}>Kontakt oss — NordPass — Oslo</div>
        <div style={{ width: '1px', height: '60px', background: 'rgba(59,111,212,0.3)', margin: '16px 0' }} />
      </div>

      {/* Main content */}
      <div style={{
        position: 'relative', zIndex: 10,
        paddingLeft: '80px', paddingRight: '5%',
        paddingTop: '120px',
        display: 'flex', flexDirection: 'column', justifyContent: 'center',
        height: '100%'
      }}>
        {/* Stamp */}
        <div style={{
          position: 'absolute', top: '130px', right: '6%',
          border: '2px solid rgba(232,148,26,0.5)',
          padding: '6px 12px',
          transform: 'rotate(3deg)',
          fontFamily: 'Georgia, serif', fontStyle: 'italic',
          fontSize: '0.65rem', color: 'rgba(232,148,26,0.7)',
          letterSpacing: '0.05em', whiteSpace: 'nowrap'
        }}>alltid tilgjengelig ✦</div>

        {/* Eyebrow */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{ width: '28px', height: '1px', background: '#E8941A' }} />
          <span style={{
            fontFamily: 'monospace', fontSize: '0.6rem',
            letterSpacing: '0.3em', color: '#E8941A',
            textTransform: 'uppercase'
          }}>Ta kontakt med oss</span>
        </div>

        {/* Giant headline */}
        <div style={{ position: 'relative' }}>
          <div style={{
            fontFamily: '"Arial Black", "Impact", sans-serif',
            fontSize: 'clamp(4rem, 11vw, 9rem)',
            fontWeight: 900,
            color: '#EEF0F2',
            lineHeight: 0.88,
            letterSpacing: '-0.05em',
            textTransform: 'uppercase'
          }}>KONTAKT</div>
          <div style={{
            fontFamily: '"Arial Black", "Impact", sans-serif',
            fontSize: 'clamp(4rem, 11vw, 9rem)',
            fontWeight: 900,
            color: 'transparent',
            WebkitTextStroke: '2px #3B6FD4',
            lineHeight: 0.88,
            letterSpacing: '-0.05em',
            textTransform: 'uppercase',
            marginLeft: 'clamp(20px, 4vw, 80px)'
          }}>OSS</div>
          <div style={{
            fontFamily: 'Georgia, "Times New Roman", serif',
            fontStyle: 'italic',
            fontSize: 'clamp(1.5rem, 3.5vw, 3rem)',
            fontWeight: 400,
            color: '#E8941A',
            lineHeight: 1,
            paddingLeft: 'clamp(8px, 1.5vw, 30px)',
            marginTop: '8px'
          }}>vi er her for deg.</div>
        </div>

        {/* Pull quote */}
        <div style={{
          marginTop: '36px',
          display: 'grid',
          gridTemplateColumns: '3px 1fr',
          gap: '16px',
          maxWidth: '480px'
        }}>
          <div style={{ background: '#E8941A', borderRadius: '2px' }} />
          <p style={{
            fontFamily: 'Georgia, serif',
            fontSize: 'clamp(0.875rem, 1.2vw, 1rem)',
            color: 'rgba(238,240,242,0.65)',
            lineHeight: 1.7,
            margin: 0,
            fontStyle: 'italic'
          }}>Spørsmål om abonnement, teknisk støtte, eller bare en hyggelig prat om norske veier — vi svarer alltid.</p>
        </div>
      </div>
    </section>);

};

export default ContactHero;